import {
  CategoryProductsToolbarSkeleton,
  CategoryProductsActiveFiltersSkeleton,
  CategoryProductsGridSkeleton,
} from '@/app/components/loadings';

const ProductsLoading = () => {
  return (
    <>
      <CategoryProductsToolbarSkeleton />

      <div className={'mb-4 lg:mb-8'}>
        <CategoryProductsActiveFiltersSkeleton pillCount={4} />
      </div>

      <CategoryProductsGridSkeleton />
    </>
  );
};

export default ProductsLoading;
